import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getDevCouriers } from 'app/store/dev/couriers/couriers.actions';
import { devCouriersState } from 'app/store/dev/couriers/couriers.selectors';
import { getDevDocuments } from 'app/store/dev/documents/documents.actions';
import { devDocumentsState } from 'app/store/dev/documents/documents.selectors';
import { resetCurrentProject } from 'app/store/project/current-project/current-project.actions';
import { defer, forkJoin, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Injectable()
export class DevStateResolver {
  constructor(private store$: Store) { }

  resolve(): Observable<any> {
    return defer(() => {
      this.store$.dispatch(getDevCouriers());
      this.store$.dispatch(getDevDocuments());

      return forkJoin({
        couriers: this.store$.select(devCouriersState).pipe(
          first(state => !state.loading && Boolean(state.isLoaded || state.error)),
        ),
        documents: this.store$.select(devDocumentsState).pipe(first(s => s.isLoaded)),
      });
    }).pipe(
      tap(() => this.store$.dispatch(resetCurrentProject())),
    );
  }
}
